import type { UseMutationProps } from '@ztechapps/common.hook'
import { useCreateSimpleHistory } from '@ztechapps/common.hook'

export const useCreateOrderSimpleHistory = ({ query: _query, ...props } = {} as unknown as UseMutationProps) => {
  return useCreateSimpleHistory({
    ...props,
    entity: 'Order',
  })
}
